import axios from 'axios';

import { BASE_CONFIG } from '../config/basic-info-config';

const instance = axios.create({
  baseURL: BASE_CONFIG.baseURL,
  timeout: 120000,
});

// 请求拦截器
instance.interceptors.request.use((config) => {
  console.log('发请求之前', config);
  // if (config.url.indexOf('http') > -1) { config.baseURL = ''}
  // if (!navigator.onLine) return false;
  // // 不需要token的接口过滤掉
  // if (!unnecessaryUrl.includes(config.url)){
  //   config.headers['X-FC-Token'] = getToken()
  // }
  // config.headers['Content-Type'] = 'application/json;charset=UTF-8'

  return config;
}, (error) => {
  console.log('请求错误', error);
  return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use((response) => {
  console.log('得到的响应数据', response);
  return response;
}, (error) => {
  console.log('响应错误', error);
  return Promise.reject(error);
});

// get请求
export function get(url, data = {}) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        params: data,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// post请求
export function post(url, data = {}) {
  console.log('ajax Params ===>', data);
  return new Promise((resolve, reject) => {
    instance.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      },
    );
  });
}
